var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#635f98",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2560 l0 -2560 2560 0 2560 0 0 2560 0 2560 -2560 0 -2560 0 0 -2560z m2151 1039 c-2 -8 -6 -38 -9 -67 l-5 -54 449 5 c335 4 469 9 529 20 118 22 263 62 330 91 32 15 62 23 66 19 9 -9 -110 -309 -137 -347 -31 -42 -105 -85 -186 -105 -122 -31 -279 -41 -675 -41 l-373 0 0 -241 c0 -224 1 -240 18 -235 231 69 991 266 1029 266 65 0 118 -35 215 -144 49 -55 96 -113 103 -127 l14 -26 -73 -6 c-118 -10 -106 29 -106 -354 l0 -335 228 4 c201 3 231 5 256 21 67 44 50 -14 -55 -189 -73 -122 -125 -174 -211 -215 l-73 -34 -925 0 -925 0 -70 33 c-88 42 -133 85 -200 193 -114 183 -138 258 -69 212 25 -16 55 -18 256 -21 l228 -4 2 719 3 718 25 33 c30 41 125 112 240 181 83 50 109 57 101 30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2835 2454 c-66 -18 -249 -68 -407 -111 l-288 -76 0 -174 0 -173 420 0 420 0 0 285 c0 222 -3 285 -12 284 -7 0 -67 -16 -133 -35z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKk);
export default __webpack_public_path__ + "static/media/kk.b804ce5e.svg";
export { ForwardRef as ReactComponent };